import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Projects } from './components/projects'
import { Features } from './components/features'
import { Career } from './components/career'
import { About } from './components/about'
import { Contact } from './components/contact'
import data from './data/data.json'
import './App.css'

const App = () => (
  <div className="shell">
    <div className="backdrop" aria-hidden="true" />
    <a className="skip-link" href="#work">
      Skip to content
    </a>

    <Navigation profile={data.profile} />

    <main>
      <Header profile={data.profile} />
      <Projects work={data.work} business={data.profile.business} />
      <Features capabilities={data.capabilities} />
      <Career
        career={data.career}
        certifications={data.certifications}
        links={data.profile.links}
      />
      <About profile={data.profile} />
      <Contact profile={data.profile} />
    </main>
  </div>
)

export default App
